































import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../../shared/helpers/enhanced-ecommerce';
import {TranslateResult} from 'vue-i18n';

@Component({
  name: 'catalog-product-sticky-add-to-cart',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  $refs!: {
    addToCart: HTMLElement;
  }

  @Prop() private readonly productData: object;

  private showElement: boolean = false;
  private addToCartIsLoading: boolean = false;

  private get isSaleable(): boolean {
    return this.$store.getters['CatalogProduct/isSaleable'] && (this.productData['in_stock'] || !this.productData['manage_stock']);
  }

  private get selectedOptions(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedOptions'];
  }


  private get getImage(): string {
    if (
      'media_gallery' in this.productData &&
      0 in this.productData['media_gallery'] &&
      'dimensions' in this.productData['media_gallery'][0] &&
      '60x60' in this.productData['media_gallery'][0]['dimensions']
    ) {
      return this.productData['media_gallery'][0]['dimensions']['60x60'];
    }

    return '';
  }


  private async productAddToCart(): Promise<void> {
    this.addToCartIsLoading = true;

    try {
      let productPayload = {
        sku: this.productData['sku'],
        qty: 1,
      };

      if (this.productData['product_type'] === 'configurable' && this.selectedOptions.length > 0) {
        const productOptions = {
          product_option: {
            extension_attributes: {
              configurable_item_options: this.selectedOptions.map(option => {
                return {
                  option_id: option['attributeId'],
                  option_value: option['selectedValue']
                }
              })
            }
          }
        }
        productPayload = Object.assign(productPayload, productOptions);
      }

      await this.$store.dispatch('CheckoutCart/addProductToQuote', productPayload);

      await this.$store.dispatch(
        'MeasurementProtocol/fireGaEvent', {
          event: 'add_to_cart',
          data: {
            product: this.productData,
            qty: 1,
          }
        }
      );

      enhancedEcommerce.addProductAddToCart(this.productData, 1);

    } catch (e) {
      const response = e.response.data;
    } finally {
      this.addToCartIsLoading = false;
    }
  }

  private mounted(): void {
    window.addEventListener('scroll', (e) => {
      const footerEl = (document.getElementsByClassName('absolute__footer')[0] as HTMLElement);
      if (window.pageYOffset > 500) {
        this.showElement = true;
        footerEl.style.marginBottom = '80px';
      } else {
        this.showElement = false;
        footerEl.style.marginBottom = '0';
      }
    });
  }
}
